import styled, { css } from 'styled-components'
import { colors } from '@chegg-ui/theme'
import { fanta } from '@chegg/fanta'
import { IconButton as OrigIconButton } from '@chegg-ui/button'
import { Move, Trash, Edit } from '@chegg-wt/core/components/Icon'

const IconAttributes = css`
  cursor: pointer;
  height: 22px;
`

export const ToolTipText = styled.div``
export const toolTipStyle = css`
  > span > div[role='tooltip'] {
    background-color: ${colors.dark};
    font-size: ${fanta.font.size.xs};
    padding: 0.6rem;
    box-shadow: unset;
    animation: none;
    width: max-content;
  }
  > span > [role='tooltip']:before {
    border-top-color: ${colors.dark};
    border-width: 0.5rem;
    margin-left: -0.5rem;
  }
  > span > [role='tooltip']:after {
    border-top-color: ${colors.dark};
    border-width: calc(0.5rem - 1px);
    margin-left: calc(-0.5rem + 1px);
  }
`

export const IconContainer = styled.div`
  height: 30px;
  width: 30px;

  transition: background-color 0.3s ease-in;
  border-radius: 50%;
  padding: 4px 0px 0px 6px;

  &:hover,
  &:focus-within {
    background-color: ${colors.skyLight};
  }
  ${toolTipStyle};
`

export const ProjectItemMenu = styled.div`
  display: flex;
  justify-content: flex-start;

  & > * + * {
    margin-left: 10px;
  }

  svg {
    margin: 0 0;
  }
`

export const MoveIcon = styled(Move)`
  ${IconAttributes}
`

export const MoveIconContainer = styled.div`
  height: 30px;
  width: 30px;

  transition: background-color 0.3s ease-in;
  border-radius: 50%;
  padding: 4px 0px 0px 3px;

  &:hover,
  &:focus-within {
    background-color: ${colors.skyLight};
  }
  ${toolTipStyle};
`

export const IconButton = styled(OrigIconButton)`
  padding: 0;
`

export const TrashIcon = styled(Trash)`
  ${IconAttributes}
`

export const EditIcon = styled(Edit)`
  ${IconAttributes}
`
